export const QUICK_FILTER_LIMIT = 5;
export const quickFiltersNamespace = 'quickFilters';
const QUICK_FILTER_MAP_DELIMITER = '/';
export const getQuickFilterUniqueKey = ({
  dataSource,
  name
}) => `${dataSource}${QUICK_FILTER_MAP_DELIMITER}${name}`;